export default __webpack_public_path__ + "static/media/thumb_10.3b01b650.webp";